import {Controller} from "stimulus"

export default class extends Controller {
  update() {
    const dateFrom = document.getElementById("date_from").value
    const dateTo = document.getElementById("date_to").value
    window.location.href = "/reservation/reports?date_from=" + encodeURIComponent(dateFrom) + "&date_to=" + encodeURIComponent(dateTo)
  }
}
